import { render, staticRenderFns } from "./in-develop-desc.vue?vue&type=template&id=521e7dc6&scoped=true&"
import script from "./in-develop-desc.vue?vue&type=script&lang=js&"
export * from "./in-develop-desc.vue?vue&type=script&lang=js&"
import style0 from "./in-develop-desc.vue?vue&type=style&index=0&id=521e7dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e7dc6",
  null
  
)

export default component.exports